import { httpClient, metaGen, customerHttp } from './_http';

const post = (url, payload, opts = {}) =>
httpClient.post(url, payload, {
    baseURL: '/api/customer-server'
});
const get = (url, payload, opts = {}) =>
httpClient.get(url, payload, {
    baseURL: '/api/customer-server'
});

  /**
 * @desc 旺季下单成功提醒
 * @param {{}} payload
 */
export const orderSuccessReminder = payload =>
post('/truck-order/order-success-reminder', {
    meta: metaGen(),
    params: payload
});

export const planArrivaldateRange = payload =>
post('/company/plan-arrival-date/range', {
    meta: metaGen(),
    params: payload
});

/**
 * @desc 合同签署- 获取港口下拉
 * @param {*} contractType:  Online 线上, Offline线下
 */
export const contractPortList = payload =>
post('/customer-contract-template/port/selector', {
    meta: metaGen(),
    params: payload
});
export const contractPortList2 = (payload) =>
  customerHttp.get(`/company-customer-rel/query-customer-agent-by-company-id?companyId=${payload}`)

/**
 * @desc 企业实名状态
 */
export const certificationStatus = payload =>
  post('/company-certification/status', {
      meta: metaGen(),
      params: payload
});

/**
 * @desc 首页轮播
 */
export const newsImgs = () => customerHttp.get('/common/searchBannerConfig?type=IMAGE&limit=2');

/**
 * @desc 视频
 */
export const homePageVideo = () => customerHttp.get('/common/searchBannerConfig?type=VIDEO&limit=1');


export const isPeakSeason = payload =>
  post('/busy-season-setting/select/create_order_document_busyseason', {
      meta: metaGen(),
      params: payload
});


// WEBPACK FOOTER //
// ./src/api/customer-server.js